import React from "react";
import { usePurchasePoModel } from "../purchasePoModel";
import { ISearchValue, SearchTypeEnum } from "@/components/YhPageHeader/Types";
import { YhPageHeader } from "@/components/YhPageHeader";
import { useDictModel } from "../../../base/dict/dictModel";
import { DictCodeEnmu } from "@/types/VrmSaDictEnums"
import useGlobalModel from "@/model/globalModel";
import zh_CN from "@/locale/zh-CN";
import en_US from "@/locale/en-US";

export function PageHeader() {
    let LanguageArr: any = {
        "zh-CN": zh_CN,
        "en-US": en_US
    }
    const { setLocale } = useGlobalModel()
    const Locale = setLocale(LanguageArr)

    const { getTreeSelectOne, getSelectedDictOne } = useDictModel();
    const { searchParam, updateSearchParam, resetSearchParam, loadData } = usePurchasePoModel();
    const searchFields = [
        {
            type: SearchTypeEnum.Input,
            // placeholder: "供应商名称",
            placeholder: Locale["Supplier Name"],
            fieldName: "supplierName",
        },
        {
            type: SearchTypeEnum.Input,
            // placeholder: "联系人",
            placeholder: Locale["Contact"],
            fieldName: "contact",
        },
        {
            type: SearchTypeEnum.Select,
            // placeholder: "单据状态",
            placeholder: Locale["Status"],
            fieldName: "status",
            options: getSelectedDictOne(DictCodeEnmu.PURCHASE)
        },
        {
            type: SearchTypeEnum.Input,
            // placeholder: "单据编号",
            placeholder: Locale["Purchase Doc No."],
            fieldName: "purchaseCode"
        },
        {
            type: SearchTypeEnum.Select,
            // placeholder: "支付状态",
            placeholder: Locale["Payment status"],
            fieldName: "payStatus",
            options: getSelectedDictOne(DictCodeEnmu.PAY_STATUS1)

        },
        {
            type: SearchTypeEnum.RangePicker,
            fieldName: "",
            // placeholder: ["制单日期起始", "制单日期结束"],
            placeholder: [Locale["CreationStartTime"], Locale["CreationEndTime"]],
            rangePickerFieldName: ["startTime", "endTime"],
            // showTime: false,
            format:"YYYY-MM-DD",
            span: 16,
            xxl: 8,
        }
    ]
    const PageHeaderTitle = <>
        <span style={{ color: "#7F7F7F" }}>{Locale["Purchase Management"]} </span>
        <span style={{ color: "#000" }}>/ {Locale["Purchase & Stock In"]}</span>
    </>
    return (
        <>
            <YhPageHeader
                title={PageHeaderTitle}
                triggerSearch={true}
                searchValues={searchParam as ISearchValue}
                searchFields={searchFields}
                onChange={updateSearchParam}
                handleSearch={loadData}
                handleReset={resetSearchParam}
            />
        </>
    );
}